module.exports = __webpack_public_path__ + "img/vol06_cup02_cover01.bc8d157f.jpg";